// extracted by mini-css-extract-plugin
module.exports = {"table":"PredictionsPreparedMaterialTable_table__2jRH6","container":"PredictionsPreparedMaterialTable_container__19trp"};